import * as palettes from "./palettes";
export default {
  palettes: palettes
};